// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stateId: __t.u64().primaryKey().name("state_id"),
  systemId: __t.string().name("system_id"),
  denKey: __t.string().name("den_key"),
  alive: __t.u32(),
  capacity: __t.u32(),
  tier: __t.u8(),
  respawnAnchor: __t.timestamp().name("respawn_anchor"),
  authorityEpoch: __t.u64().name("authority_epoch"),
  updatedAt: __t.timestamp().name("updated_at"),
});
